<template lang="pug">
  #app
    router-view
</template>

<script>

export default {
  name: 'app'
}
</script>

<style lang="scss">
  @import './scss/main.scss';
  body, button, input, select, textarea, a {
    font-family: $family-sans-serif;
    font-weight: normal;
    font-style: normal;
  }
  .toasted.bubble {
    font-weight: 600;
    background-color: #ff4d4d;
  }

  .toasted.toasted-primary {
    font-weight: 600;
    background-color: #057d8d;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue